"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var IStorage = require("./interfaces/IStorage");
var _require = require("./adapters"),
  LocalStorageAdapter = _require.LocalStorageAdapter;
var Storage = /*#__PURE__*/function (_IStorage) {
  function Storage(adapter) {
    var _this;
    (0, _classCallCheck2["default"])(this, Storage);
    _this = _callSuper(this, Storage);
    _this.adapter = adapter !== null && adapter !== void 0 ? adapter : new LocalStorageAdapter();
    return _this;
  }
  (0, _inherits2["default"])(Storage, _IStorage);
  return (0, _createClass2["default"])(Storage, [{
    key: "get",
    value: function get(key) {
      var _this$adapter;
      return (_this$adapter = this.adapter) === null || _this$adapter === void 0 ? void 0 : _this$adapter.getItem(key);
    }
  }, {
    key: "set",
    value: function set(key, value) {
      var _this$adapter2;
      var result = (_this$adapter2 = this.adapter) === null || _this$adapter2 === void 0 ? void 0 : _this$adapter2.setItem(key, value);
      this.emit(key, value);
      return result;
    }
  }, {
    key: "onEvent",
    value: function onEvent(event, fn) {
      var subscription = this.on(event, fn, {
        objectify: true
      });
      return function () {
        subscription.off();
      };
    }
  }, {
    key: "remove",
    value: function remove(key) {
      var _this$adapter3;
      return (_this$adapter3 = this.adapter) === null || _this$adapter3 === void 0 ? void 0 : _this$adapter3.removeItem(key);
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this$adapter4;
      return (_this$adapter4 = this.adapter) === null || _this$adapter4 === void 0 ? void 0 : _this$adapter4.clear();
    }
  }, {
    key: "key",
    value: function key(index) {
      var _this$adapter5;
      return (_this$adapter5 = this.adapter) === null || _this$adapter5 === void 0 ? void 0 : _this$adapter5.key(index);
    }
  }]);
}(IStorage);
module.exports = Storage;